module.exports = __webpack_public_path__ + "static/media/about.a613b28d.png";